module.exports = __webpack_public_path__ + "img/horizontal_3_4_r_7016.9086429f.png";